//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    actionSim: Function,
    actionNao: Function,
    mdClickOutsideToClose: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    open() {
      this.$refs.voltarDialog.open();
    },
    close() {
      this.$refs.voltarDialog.close();
    },
    defaultClose() {
      this.close();
    },
    defaultActionSim() {
      this.close();
      if (this.actionSim) {
        this.actionSim();
      }
    },
    defaultActionNao() {
      this.close();
      if (this.actionNao) {
        this.actionNao();
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/shared-components/ModalVoltar.vue?vue&type=script&lang=js&